import { FiscalpopCFDI } from '../../models/Factura';
import { buildProxyUrl, FiscalpopRequestOptions, getJson } from './fiscalpop.base';

export interface FindByDateRangeOptions extends FiscalpopRequestOptions {
    conceptos?: boolean;
    impuestos?: boolean;
}

export const findCfdiByDateRange = (
    authToken: string,
    startMs: number,
    endMs: number,
    options: FindByDateRangeOptions = {},
): Promise<FiscalpopCFDI[]> => {
    const { conceptos, impuestos, ...req } = options;
    return getJson<FiscalpopCFDI[]>(
        `/cfdi/findBy/${authToken}/${startMs}/${endMs}`,
        { conceptos, impuestos },
        req,
    );
};

export const findCfdiByUuid = (
    authToken: string,
    uuid: string,
    options: FiscalpopRequestOptions = {},
): Promise<FiscalpopCFDI[]> => {
    return getJson<FiscalpopCFDI[]>(`/cfdi/find/${authToken}/${uuid}`, undefined, options);
};

export interface CfdiCancelStatusResponse {
    toCancelProcess: 'cancelable sin aceptación' | 'cancelable con aceptación' | 'no cancelable';
    estado: boolean;
    cancelStatus: string;
}

export const getCfdiCancelStatus = (
    authToken: string,
    uuid: string,
    options: FiscalpopRequestOptions = {},
): Promise<CfdiCancelStatusResponse> => {
    return getJson<CfdiCancelStatusResponse>(`/cfdi/status/${authToken}/${uuid}`, undefined, options);
};

export type CfdiDownloadKind = 'pdf' | 'xml';

/**
 * Builds a URL suitable for use in an <a href download> anchor. The request
 * hits our back-end proxy, which appends the Fiscalpop secret before forwarding.
 */
export const buildCfdiDownloadUrl = (
    authToken: string,
    uuid: string,
    kind: CfdiDownloadKind,
): string => {
    return buildProxyUrl(`/cfdi/download/${kind}/${authToken}`, { uuid });
};

// Mimics the above but for payments
export const buildPaymentCfdiDownloadUrl = (
    authToken: string,
    uuid: string,
    kind: CfdiDownloadKind,
): string => {
    return buildProxyUrl(`/payments/download/${kind}/${authToken}`, { uuid });
};
